// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23000000%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ecosystem Dashboard Layout */
.ecosystem-dashboard {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  padding: 20px;
}

/* Project Card Styles */
.project-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 1px solid var(--border-color, #e0e0e0);
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  position: relative;
}

.project-card:hover {
  transform: translateY(-2px);
  border-color: #9FE2BF;
  box-shadow: 0 0 0 2px rgba(159, 226, 191, 0.1);
}

.banner-container {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-and-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-top: -30px;
  position: relative;
  z-index: 1;
}

.logo-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid white;
  background: white;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.social-links {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.social-link {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  transition: all 0.2s ease;
  background: white;
}

.social-link:hover {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

.project-info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px;
}

.project-name {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
}

.project-description {
  color: var(--text-secondary, #666);
  margin: 0;
  line-height: 1.5;
  flex-grow: 1;
  margin-bottom: 40px;
}

/* Project card tags container */
.project-tags {
  margin-top: auto;
  /* Push to bottom of card */
  padding: 0px 0 0px 10px;
  display: flex;
  justify-content: left;
  /* This should align them left */
}

/* Type tag on the left */
.project-type {
  position: absolute;
  top: 20px;
  /* Align with top of banner */
  left: 20px;
  /* Same left padding as logo */
  z-index: 2;
  /* Ensure it's above the banner */
  background: white;
  border: 1px solid #e0e0e0;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
}

/* Special tags grid on the right */
.tags-grid {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
}

/* Base styles for all tags */
.project-type,
.native-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 18px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Special tags styling */
.native-tag {
  background: #9FE2BF;
  color: white;
}

/* Hover states */
.native-tag:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* Active states */
.native-tag.active {
  opacity: 1;
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.native-tag.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #9FE2BF;
}

.native-tag.clickable:hover {
  background: white;
  color: #9FE2BF;
  border-color: #9FE2BF;
}

.native-tag.clickable.active {
  background: #9FE2BF;
  color: white;
  box-shadow: 0 2px 4px rgba(159, 226, 191, 0.2);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 10px;
  }

  .project-card {
    max-width: 100%;
  }
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 0;
  /* Remove any bottom margin */
}

.filter-group label {
  font-size: 14px;
  color: var(--text-secondary, #666);
  margin-bottom: 4px;
  /* Consistent spacing below labels */
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 6px;
  font-size: 14px;
  width: 200px;
  min-width: 200px;
  height: 35px;
  background: white;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  padding-right: 30px;
  white-space: nowrap;
}

.filter-select:hover {
  background-color: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

.filter-select:focus {
  outline: none;
  border-color: #9FE2BF;
}

.filter-select option {
  text-align: center;
  background: white;
  color: black;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .filters-container {
    flex-direction: column;
    gap: 15px;
  }
}

.project-type.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.project-type.clickable:hover {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

.native-tag.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #9FE2BF;
}

.native-tag.clickable:hover {
  background: white;
  color: #9FE2BF;
  border-color: #9FE2BF;
}

.native-tag.clickable.active {
  background: #9FE2BF;
  color: white;
  box-shadow: 0 2px 4px rgba(159, 226, 191, 0.2);
}

.monad-madness-tag {
  display: inline-block;
  padding: 6px 12px;
  background: #4DDB00;
  border-radius: 20px;
  color: white;
}

.monad-madness-tag.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #4DDB00;
}

.monad-madness-tag.clickable:hover {
  background: white;
  color: #4DDB00;
  border-color: #4DDB00;
}

.monad-madness-tag.clickable.active {
  background: #4DDB00;
  color: white;
  box-shadow: 0 2px 4px rgba(77, 219, 0, 0.2);
}

.project-type.clickable.active {
  background: #d0d0d0;
  transform: scale(1.05);
}

.clear-filters-button:hover {
  background: #f5f5f5;
  border-color: #00E673;
}

.clear-filters-button:active {
  background: #e5e5e5;
}

/* Project card text hover effect */
.project-card:hover .project-name {
  color: #2E8B57;
}

.project-card:hover .project-description {
  color: #2E8B57;
}

/* Social links hover effect */
.social-link:hover {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

/* Type tag hover effect */
.project-type.clickable:hover {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

/* Native/Monad First tag hover effect */
.native-tag.clickable:hover {
  background: white;
  color: #9FE2BF;
  border-color: #9FE2BF;
}

/* Monad Madness tag hover effect */
.monad-madness-tag.clickable:hover {
  background: white;
  color: #4DDB00;
  border-color: #4DDB00;
}

/* Filter buttons (replacing dropdowns) */
.filter-button {
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.filter-button:hover {
  border-color: #00E673;
}

.filter-button.active {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

/* Common styles for all filter buttons */
.filter-button,
.clear-filters-button {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 6px;
  font-size: 14px;
  width: 200px;
  min-width: 200px;
  height: 35px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Hover state for all buttons */
.filter-button:hover,
.clear-filters-button:hover {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

/* Active state for filter buttons */
.filter-button.active {
  background: #9FE2BF;
  color: white;
  border-color: #9FE2BF;
}

/* Filter container alignment */
.filters-container {
  display: flex;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  margin: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  /* Softer, more rounded shadow */
  align-items: center;
  justify-content: center;
  min-height: 90px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Filter select styling to match buttons */
.filter-select {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 6px;
  font-size: 14px;
  width: 200px;
  min-width: 200px;
  height: 35px;
  background: white;
  cursor: pointer;
}

.filter-select:hover {
  border-color: #00E673;
}

/* Fix button text wrapping */
.clear-filters-button {
  white-space: nowrap;
  /* Prevent text wrapping */
  width: auto;
  /* Allow button to fit content */
  min-width: 150px;
  /* Maintain minimum width */
}

/* Fix label alignment */
.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 0;
  /* Remove any bottom margin */
}

.filter-group label {
  margin-bottom: 4px;
  /* Consistent spacing below labels */
}

/* Ensure consistent heights */
.filter-select,
.filter-button,
.clear-filters-button {
  height: 45px;
  line-height: normal;
  padding: 8px 12px;
}

.hl-ecosystem-dashboard-title {
  color: #002475;
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: bold;
}

.hl-ecosystem-dashboard-title:hover {
  color: #9FE2BF;
}

/* Add styles for accelerator tag */
.accelerator-tag.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #32CD32;
}

.accelerator-tag.clickable:hover {
  background: white !important;
  color: #32CD32 !important;
  border-color: #32CD32 !important;
}

.accelerator-tag.clickable.active {
  background: #32CD32;
  color: white;
  box-shadow: 0 2px 4px rgba(50, 205, 50, 0.2);
}

/* Add styles for jumpstart tag */
.jumpstart-tag.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #00E673;
}

.jumpstart-tag.clickable:hover {
  background: white !important;
  color: #00E673 !important;
  border-color: #00E673 !important;
}

.jumpstart-tag.clickable.active {
  background: #00E673;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 230, 115, 0.2);
}

.no-results-message {
  text-align: center;
  padding: 40px;
  color: var(--text-secondary, #666);
  font-size: 18px;
  margin: 20px auto;
  max-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.disclaimer {
  margin-top: 40px;
  padding: 20px;
  color: #666;
  font-size: 12px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/hyperliquid_ecosystem.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,8CAA8C;EAC9C,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,8BAA8B;EAC9B,UAAU;EACV,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAwR;EACxR,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;;EAEE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;EAEE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Ecosystem Dashboard Layout */\n.ecosystem-dashboard {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 24px;\n  padding: 20px;\n}\n\n/* Project Card Styles */\n.project-card {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  border: 1px solid var(--border-color, #e0e0e0);\n  transition: transform 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  min-height: 400px;\n  position: relative;\n}\n\n.project-card:hover {\n  transform: translateY(-2px);\n  border-color: #9FE2BF;\n  box-shadow: 0 0 0 2px rgba(159, 226, 191, 0.1);\n}\n\n.banner-container {\n  position: relative;\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n}\n\n.banner-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.logo-and-links {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  margin-top: -30px;\n  position: relative;\n  z-index: 1;\n}\n\n.logo-container {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 3px solid white;\n  background: white;\n}\n\n.logo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.social-links {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.social-link {\n  padding: 6px 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  text-decoration: none;\n  color: #333;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.social-link:hover {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n.project-info {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 20px;\n}\n\n.project-name {\n  margin: 0 0 16px 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.project-description {\n  color: var(--text-secondary, #666);\n  margin: 0;\n  line-height: 1.5;\n  flex-grow: 1;\n  margin-bottom: 40px;\n}\n\n/* Project card tags container */\n.project-tags {\n  margin-top: auto;\n  /* Push to bottom of card */\n  padding: 0px 0 0px 10px;\n  display: flex;\n  justify-content: left;\n  /* This should align them left */\n}\n\n/* Type tag on the left */\n.project-type {\n  position: absolute;\n  top: 20px;\n  /* Align with top of banner */\n  left: 20px;\n  /* Same left padding as logo */\n  z-index: 2;\n  /* Ensure it's above the banner */\n  background: white;\n  border: 1px solid #e0e0e0;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n}\n\n/* Special tags grid on the right */\n.tags-grid {\n  display: flex;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n/* Base styles for all tags */\n.project-type,\n.native-tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 16px;\n  border-radius: 18px;\n  font-size: 12px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Special tags styling */\n.native-tag {\n  background: #9FE2BF;\n  color: white;\n}\n\n/* Hover states */\n.native-tag:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n/* Active states */\n.native-tag.active {\n  opacity: 1;\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.native-tag.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid #9FE2BF;\n}\n\n.native-tag.clickable:hover {\n  background: white;\n  color: #9FE2BF;\n  border-color: #9FE2BF;\n}\n\n.native-tag.clickable.active {\n  background: #9FE2BF;\n  color: white;\n  box-shadow: 0 2px 4px rgba(159, 226, 191, 0.2);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .projects-grid {\n    grid-template-columns: 1fr;\n    padding: 10px;\n  }\n\n  .project-card {\n    max-width: 100%;\n  }\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 0;\n  /* Remove any bottom margin */\n}\n\n.filter-group label {\n  font-size: 14px;\n  color: var(--text-secondary, #666);\n  margin-bottom: 4px;\n  /* Consistent spacing below labels */\n}\n\n.filter-select {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 6px;\n  font-size: 14px;\n  width: 200px;\n  min-width: 200px;\n  height: 35px;\n  background: white;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.2s ease;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 16px;\n  padding-right: 30px;\n  white-space: nowrap;\n}\n\n.filter-select:hover {\n  background-color: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #9FE2BF;\n}\n\n.filter-select option {\n  text-align: center;\n  background: white;\n  color: black;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .filters-container {\n    flex-direction: column;\n    gap: 15px;\n  }\n}\n\n.project-type.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.project-type.clickable:hover {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n.native-tag.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid #9FE2BF;\n}\n\n.native-tag.clickable:hover {\n  background: white;\n  color: #9FE2BF;\n  border-color: #9FE2BF;\n}\n\n.native-tag.clickable.active {\n  background: #9FE2BF;\n  color: white;\n  box-shadow: 0 2px 4px rgba(159, 226, 191, 0.2);\n}\n\n.monad-madness-tag {\n  display: inline-block;\n  padding: 6px 12px;\n  background: #4DDB00;\n  border-radius: 20px;\n  color: white;\n}\n\n.monad-madness-tag.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid #4DDB00;\n}\n\n.monad-madness-tag.clickable:hover {\n  background: white;\n  color: #4DDB00;\n  border-color: #4DDB00;\n}\n\n.monad-madness-tag.clickable.active {\n  background: #4DDB00;\n  color: white;\n  box-shadow: 0 2px 4px rgba(77, 219, 0, 0.2);\n}\n\n.project-type.clickable.active {\n  background: #d0d0d0;\n  transform: scale(1.05);\n}\n\n.clear-filters-button:hover {\n  background: #f5f5f5;\n  border-color: #00E673;\n}\n\n.clear-filters-button:active {\n  background: #e5e5e5;\n}\n\n/* Project card text hover effect */\n.project-card:hover .project-name {\n  color: #2E8B57;\n}\n\n.project-card:hover .project-description {\n  color: #2E8B57;\n}\n\n/* Social links hover effect */\n.social-link:hover {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n/* Type tag hover effect */\n.project-type.clickable:hover {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n/* Native/Monad First tag hover effect */\n.native-tag.clickable:hover {\n  background: white;\n  color: #9FE2BF;\n  border-color: #9FE2BF;\n}\n\n/* Monad Madness tag hover effect */\n.monad-madness-tag.clickable:hover {\n  background: white;\n  color: #4DDB00;\n  border-color: #4DDB00;\n}\n\n/* Filter buttons (replacing dropdowns) */\n.filter-button {\n  padding: 8px 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.filter-button:hover {\n  border-color: #00E673;\n}\n\n.filter-button.active {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n/* Common styles for all filter buttons */\n.filter-button,\n.clear-filters-button {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 6px;\n  font-size: 14px;\n  width: 200px;\n  min-width: 200px;\n  height: 35px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n/* Hover state for all buttons */\n.filter-button:hover,\n.clear-filters-button:hover {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n/* Active state for filter buttons */\n.filter-button.active {\n  background: #9FE2BF;\n  color: white;\n  border-color: #9FE2BF;\n}\n\n/* Filter container alignment */\n.filters-container {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  margin: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  /* Softer, more rounded shadow */\n  align-items: center;\n  justify-content: center;\n  min-height: 90px;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Filter select styling to match buttons */\n.filter-select {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 6px;\n  font-size: 14px;\n  width: 200px;\n  min-width: 200px;\n  height: 35px;\n  background: white;\n  cursor: pointer;\n}\n\n.filter-select:hover {\n  border-color: #00E673;\n}\n\n/* Fix button text wrapping */\n.clear-filters-button {\n  white-space: nowrap;\n  /* Prevent text wrapping */\n  width: auto;\n  /* Allow button to fit content */\n  min-width: 150px;\n  /* Maintain minimum width */\n}\n\n/* Fix label alignment */\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 0;\n  /* Remove any bottom margin */\n}\n\n.filter-group label {\n  margin-bottom: 4px;\n  /* Consistent spacing below labels */\n}\n\n/* Ensure consistent heights */\n.filter-select,\n.filter-button,\n.clear-filters-button {\n  height: 45px;\n  line-height: normal;\n  padding: 8px 12px;\n}\n\n.hl-ecosystem-dashboard-title {\n  color: #002475;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.hl-ecosystem-dashboard-title:hover {\n  color: #9FE2BF;\n}\n\n/* Add styles for accelerator tag */\n.accelerator-tag.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid #32CD32;\n}\n\n.accelerator-tag.clickable:hover {\n  background: white !important;\n  color: #32CD32 !important;\n  border-color: #32CD32 !important;\n}\n\n.accelerator-tag.clickable.active {\n  background: #32CD32;\n  color: white;\n  box-shadow: 0 2px 4px rgba(50, 205, 50, 0.2);\n}\n\n/* Add styles for jumpstart tag */\n.jumpstart-tag.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid #00E673;\n}\n\n.jumpstart-tag.clickable:hover {\n  background: white !important;\n  color: #00E673 !important;\n  border-color: #00E673 !important;\n}\n\n.jumpstart-tag.clickable.active {\n  background: #00E673;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 230, 115, 0.2);\n}\n\n.no-results-message {\n  text-align: center;\n  padding: 40px;\n  color: var(--text-secondary, #666);\n  font-size: 18px;\n  margin: 20px auto;\n  max-width: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.disclaimer {\n  margin-top: 40px;\n  padding: 20px;\n  color: #666;\n  font-size: 12px;\n  text-align: center;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
